import(/* webpackMode: "eager" */ "/vercel/path0/web/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/tokens.generated.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/skin.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/components/CookieConsent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/components/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/components/SiteFooter.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Archivo\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-archivo\"}],\"variableName\":\"archivo\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"IBM_Plex_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\"],\"display\":\"swap\",\"variable\":\"--font-mono\"}],\"variableName\":\"plexMono\"}");
